import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download, Loader2, BookOpen, Clock } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import BookNotesDialog from "./BookNotesDialog";
import LessonProgressDialog from "./LessonProgressDialog";

export function downloadBook(slug, setBusy) {
  setBusy(slug);
  return api.get(`/shop/books/${slug}/download`, { responseType: "blob" })
    .then((r) => { const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = `Velocity-${slug}.pdf`; a.click(); URL.revokeObjectURL(a.href); })
    .catch(async (e) => { let msg = "Download failed"; try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch { /* ignore */ } toast.error(msg); })
    .finally(() => setBusy(""));
}

export default function BookLibrary() {
  const [books, setBooks] = useState(null); const [busy, setBusy] = useState("");
  useEffect(() => { api.get("/shop/library").then((r) => setBooks(r.data)).catch(() => setBooks([])); }, []);
  if (!books?.length) return null;
  return (
    <section className="p-5 rounded-2xl bg-[#131722] border border-cyan-400/30 space-y-3" data-testid="book-library">
      <div className="flex items-center gap-2"><BookOpen className="w-4 h-4 text-cyan-400" /><h2 className="font-semibold">Your digital library</h2><span className="text-xs text-slate-500">{books.length} booklet{books.length === 1 ? "" : "s"} · {books.filter((b) => (b.lessons_done || []).length >= b.lessons_total).length} completed</span><Link to="/shop?cat=Digital%20Books" className="ml-auto text-xs text-cyan-300">Browse more</Link></div>
      <div className="grid sm:grid-cols-2 gap-2">
        {books.map((b) => (
          <div key={b.slug} className="flex items-center gap-3 p-2 rounded-xl bg-[#0B0D12] border border-slate-800" data-testid={`library-book-${b.slug}`}>
            <img src={b.cover} alt="" className="w-10 h-14 rounded-lg object-cover" />
            <div className="flex-1 min-w-0"><p className="text-sm font-semibold truncate">{String(b.n).padStart(2, "0")} · {b.title}</p><p className="text-[11px] text-slate-500 truncate">{b.tagline}</p></div>
            <LessonProgressDialog book={b} onChange={(d) => setBooks((s) => s.map((x) => (x.slug === d.slug ? { ...x, lessons_done: d.lessons_done } : x)))} />
            <BookNotesDialog slug={b.slug} title={b.title} />
            {b.ready ? <button onClick={() => downloadBook(b.slug, setBusy)} disabled={!!busy} className="h-8 px-3 rounded-md bg-cyan-400 text-slate-950 text-xs font-semibold inline-flex items-center gap-1 hover:bg-cyan-300" data-testid={`library-download-${b.slug}`}>{busy === b.slug ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Download className="w-3.5 h-3.5" />}PDF</button>
              : <span className="text-[10px] font-mono text-amber-300 inline-flex items-center gap-1" title="We'll email you when it's ready" data-testid={`library-pending-${b.slug}`}><Clock className="w-3 h-3" />PREPARING</span>}
          </div>
        ))}
      </div>
    </section>
  );
}
